
import axiosInstance from "../utils/AxiosInstance";
import { getAuthToken } from "../utils/commonHelper";

const API_URL = `${process.env.REACT_APP_API_URL}`; // Replace with your actual API URL



// Fetch all room services with pagination
export const fetchOtherServicesTable = async (page: number, limit: number, lan: string) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/${lan}/other-services/table?page=${page}&limit=${limit}`, { headers: customHeaders });
  return response.data;
};

// Fetch all Other services
export const fetchOtherServices = async (lan: string) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/${lan}/other-services`, { headers: customHeaders });
  return response.data;
};

// Fetch a Other service by ID
export const fetchOtherServiceById = async (id: string, lan: string) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/${lan}/other-services/${id}`, { headers: customHeaders });
  return response.data;
};

// Create a new Other service
export const addOtherService = async (newOtherService: { name: string; description: string; photo: string; }) => {
  const customHeaders = {
    'Content-Type': 'multipart/form-data',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.post(`${API_URL}/other-services`, newOtherService, { headers: customHeaders });
  return response.data;
};

// Edit an existing Other service
export const updateOtherService = async (id: string, updatedOtherService: { name: string; description: string; photo?: string }, lan: string) => {

  const response = await axiosInstance.put(`${API_URL}/${lan}/other-services/${id}`, updatedOtherService, {
    headers: {
      'Content-Type': 'multipart/form-data', // If photo is included as a file
      'Authorization': `Bearer ${getAuthToken()}`
    }
  });
  return response.data;
};

// Delete a Other service
export const removeOtherService = async (id: string) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };

  const response = await axiosInstance.delete(`${API_URL}/other-services/${id}`, { headers: customHeaders });
  return response.data;
};


